import { FstaFlags } from "./goimports/fs_featureflags_fsta";
import { FstaFlagDefaults, FstaFlagTypes } from "./fsta_metadata";

// FeatureFlags is the old name for FstaFlags.
export type FeatureFlags = FstaFlags

// FeatureFlagsDefault is the old name for FstaFlagsDefaults.
export const FeatureFlagDefaults = FstaFlagDefaults

// FeatureFlagsType is the old name for FstaFlagsTypes.
export const FeatureFlagTypes = FstaFlagTypes
